<template>
  <div class="flex flex-col gap-6">
    <div class="flex gap-2 text-primary">
      <v-icon>
        $statsHeader
      </v-icon>
      <span class="text-xl font-medium">การวิเคราะห์</span>
    </div>
    <div class="p-5 bg-white rounded-semi-md flex flex-col gap-7">
      <AnalyzeFacebookPixel />
      <AnalyzeFacebookVerifyDomain />
      <AnalyzeGoogleAnalysis />
    </div>
    <v-card flat>
      <v-card-text>
        <div class="flex flex-col sm:flex-row gap-1 sm:gap-3">
          <span class="text-h3-headline">Ad Event สำหรับ Facebook Page</span>
          <AdEventCreate />
          <v-spacer />
          <AdEventGuide />
        </div>
        <AdEventTable />
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import AnalyzeFacebookPixel from './AnalyzeFacebookPixel.vue'
import AnalyzeFacebookVerifyDomain from './AnalyzeFacebookVerifyDomain.vue'
import AnalyzeGoogleAnalysis from './AnalyzeGoogleAnalysis.vue'
import AdEventCreate from './AdEventCreate.vue'
import AdEventGuide from './AdEventGuide.vue'
import AdEventTable from './AdEventTable.vue'

export default {
  name: 'Analyze',
  components: {
    AnalyzeFacebookPixel,
    AnalyzeFacebookVerifyDomain,
    AnalyzeGoogleAnalysis,
    AdEventCreate,
    AdEventGuide,
    AdEventTable
  }
}
</script>
